var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnectedNumbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4978 68C52.9981 68 67.9955 53.0015 67.9955 34.5C67.9955 15.9985 52.9981 1 34.4978 1C15.9975 1 1 15.9985 1 34.5C1 53.0015 15.9975 68 34.4978 68Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.749 13.3945C29.749 13.3945 28.5167 20.5851 21.1233 22.0447C21.1233 22.0447 14.9382 23.2411 11.4688 16.9599C11.4688 16.9599 20.6687 22.7985 29.749 13.3945Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2406 41.3793C27.3107 41.3793 30.6101 36.8369 30.6101 31.2336C30.6101 25.6303 27.3107 21.0879 23.2406 21.0879C19.1706 21.0879 15.8711 25.6303 15.8711 31.2336C15.8711 36.8369 19.1706 41.3793 23.2406 41.3793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4602 38.9621C26.4952 38.9621 28.1449 36.6909 28.1449 33.8893C28.1449 31.0876 26.4952 28.8164 24.4602 28.8164C22.4251 28.8164 20.7754 31.0876 20.7754 33.8893C20.7754 36.6909 22.4251 38.9621 24.4602 38.9621Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.998 13.3945C36.998 13.3945 38.2303 20.5851 45.6237 22.0447C45.6237 22.0447 51.8088 23.2411 55.2782 16.9599C55.2782 16.9599 46.0783 22.7985 36.998 13.3945Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8949 41.3793C48.9649 41.3793 52.2644 36.8369 52.2644 31.2336C52.2644 25.6303 48.9649 21.0879 44.8949 21.0879C40.8248 21.0879 37.5254 25.6303 37.5254 31.2336C37.5254 36.8369 40.8248 41.3793 44.8949 41.3793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1145 38.9621C48.1495 38.9621 49.7992 36.6909 49.7992 33.8893C49.7992 31.0876 48.1495 28.8164 46.1145 28.8164C44.0794 28.8164 42.4297 31.0876 42.4297 33.8893C42.4297 36.6909 44.0794 38.9621 46.1145 38.9621Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5703 53.9297L46.1144 49.6465",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedNumbIcon);
export default __webpack_public_path__ + "static/media/disconnected-numb-icon.a89ac85b606ff02f5df5c759613a0f1d.svg";
export { ForwardRef as ReactComponent };